import AdsClick from "@mui/icons-material/AdsClick";
import { Button } from "@mui/material";
import React from "react";

/**
 * Footer actions for the Goto ID dialog.
 *
 * `canPick` is false on `/staff/id/:id`: that route renders nothing behind the
 * dialog, so closing it to pick from the page would strand the user on a blank
 * screen with no way back until the `:id` param changes.
 */
export function buildGotoUuidActions({
  canPick,
  canReset,
  onPickFromPage,
  onReset,
}: {
  canPick: boolean;
  canReset: boolean;
  onPickFromPage: () => void;
  onReset: () => void;
}): React.ReactElement[] {
  const actions: React.ReactElement[] = [];

  if (canPick) {
    actions.push(
      <Button
        key="pick"
        onClick={onPickFromPage}
        size="small"
        startIcon={<AdsClick fontSize="small" />}
      >
        Pick from page
      </Button>
    );
  }

  if (canReset) {
    actions.push(
      <Button key="reset" onClick={onReset} size="small">
        Look up another
      </Button>
    );
  }

  return actions;
}
